




































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import {
  saveProductOrder,
  queryMyOrder,
  queryWaitBuyerPay,
  deleteProductOrder,
  pay
} from '@/api/product/order'
import ProductOrder from '@/model/product/productOrder'
import Product from '@/model/product/product'
import { PayProduct } from '@/model/product/productOrder'
import { queryByStatus, getCouponById } from '@/api/coupon/coupon'
import Coupon from '@/model/coupon/coupon'

import { DeleteShoppingCart } from '@/model/product/shoppingCart'
import UserAgreement from '../components/user_agreement.vue'
import Empty from './empty_order.vue'

import QRCode from 'qrcode'
import PayResult from '@/model/product/payResult'
import { Account, fetchAccountWithoutRedirect } from 'ykd-base/account'
import LocalStorage from '@/apps/website/utils/localstorage'
import ChooseCoupons from './components/choose_coupons.vue'
import { getCourseProduct } from '@/api/product/product'
import Spinner from '@/apps/website/components/Spinner.vue'
import { queryWxOrder } from '@/api/product/order'
@Component({
  components: {
    UserAgreement,
    ChooseCoupons,
    Spinner,
    Empty
  }
})
export default class Order extends Vue {
  private account!: Account
  private payChannels = [
    {
      type: 'WEIXIN',
      title: '微信',
      icon:
        'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/done/website/wexin.png'
    },
    {
      type: 'ALIPAY',
      title: '支付宝',
      icon:
        'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/done/website/zhifubao.png'
    }
  ]
  private couponDatas: Coupon[] = []
  private empty: boolean = false
  private couponData: Coupon = {}
  private productOrder: ProductOrder = {}
  private productOrderId: string = ''
  private productName: string = ''
  private productImg = ''
  private isEmpty: boolean = false
  private numberOf: number = 0
  private localVisible2: boolean = false
  private paySuccessDialog: boolean = false
  private defalutCode: string =
    'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/done/website/defalutcode.png'
  private isloading: boolean = false
  private localVisible: boolean = false
  private payProduct: PayProduct = {}
  private totalPrice: number = 0
  private validity: string = ''
  private zhujiao: string = ''
  private coupons: string = ''
  private combination: number = 0
  private accountId: string = ''
  private selectPayType: string = 'WEIXIN'
  private deleteProductParam: DeleteShoppingCart = {}
  private payResult: PayResult = {}
  private alipayDialog: any = ''
  private products: Product[] = []
  private isClickBt: boolean = true
  private storage: LocalStorage = new LocalStorage()
  private payBtnStatus: string = '立即支付'
  private isShow: boolean = false
  private isShowCoupon: boolean = false
  private originalTotalPrice: number = 0
  private originalCouponDatas: Coupon[] = []
  private dialogPayText: string = '保存付款码到相册，打开支付宝扫码支付'

  // 生成的二维码链接
  private canvasUrl: string = ''
  // 二维码图片地址链接
  private imgUrl: string = ''
  async mounted() {
    this.isClickBt = true
    //取消底部联系我们页面
    this.$emit('changeFooterConfig', {
      hasFooter: false,
      paddingBottom: 0
    })

    if (this.$route.query.status) {
      //弹窗提示购买成功
      this.$ykdmessage({
        message: '购买成功，快去PC端学习吧',
        duration: 1500,
        cancel: () => {},
        type: 'success'
      })
    }

    //判断路径是否有productorderId
    const productOrderId = this.$route.query.productorderId as string

    if (productOrderId) {
      this.isEmpty = true
      this.initPayType()
      //查询订单信息
      this.productOrderId = productOrderId
      const productOrder = await queryMyOrder('', '', this.productOrderId, true)
      this.productOrder = productOrder[0]
      //重新计算价格
      this.accountId = productOrder[0].accountId!
      this.products = productOrder[0].products!
      this.renderOrder()

      await this.initCoupon()
      if (this.productOrder.couponId) {
        this.isShowCoupon = true
        this.couponData = await getCouponById(this.productOrder.couponId)
      }
      await this.initPayPlatform()
    } else {
      this.account = await fetchAccountWithoutRedirect()

      if (this.account) {
        this.accountId = this.account.id!
      }
      //判断是否未支付的订单
      const hasBuyerPay = await this.WaitBuyerPay()

      if (hasBuyerPay) {
        return
      }
      await this.initOrder()
    }
  }

  async initOrder() {
    await this.getProducts()
    //计算价格赋值
    this.renderOrder()
    await this.initCoupon()
    await this.initPayPlatform()
  }

  //关闭支付成功弹窗提示
  shutdown() {
    // @ts-ignore
    window.WeixinJSBridge.call('closeWindow')
  }
  selectChannel(type: string) {
    this.selectPayType = type
  }
  getLog() {
    return 'background: url(https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/done/website/couponsrighticon.png)no-repeat center;'
  }
  //打开免责协议
  freeagreementBtn() {
    ;(this.$refs.open as UserAgreement).openComponent()
  }
  // 弹窗
  showWindow(isShow: boolean) {
    this.isShow = isShow
  }
  //使用优惠卷
  useCoupon(data: any) {
    this.couponData = data

    //重新计算金额
    if (JSON.stringify(this.couponData) != '{}') {
      this.totalPrice =
        Math.floor(
          (this.originalTotalPrice -
            ((this.couponData &&
              this.couponData.couponDefine &&
              this.couponData.couponDefine.discountAmount) ||
              0)) *
            100
        ) / 100

      this.coupons = '-' + this.couponData.couponDefine!.discountAmount!
    }
  }

  //打开优惠卷弹窗
  getMyCoupon(isShow: boolean) {
    if (this.couponDatas && this.couponDatas.length > 0) {
      this.isShow = isShow
    }
  }
  //使用优惠卷动态的改变显示价格
  @Watch('couponData')
  initPrice() {
    if (JSON.stringify(this.couponData) != '{}') {
      this.totalPrice =
        Math.floor(
          (this.originalTotalPrice -
            ((this.couponData &&
              this.couponData.couponDefine &&
              this.couponData.couponDefine.discountAmount) ||
              0)) *
            100
        ) / 100

      this.coupons = '-' + this.couponData.couponDefine!.discountAmount!
    }
  }
  //初始化优惠卷
  async initCoupon() {
    this.couponData = {}
    //判断是否有优惠卷
    if (this.originalCouponDatas && this.originalCouponDatas.length === 0) {
      this.originalCouponDatas = await queryByStatus(false, 'UNUSER')
    }

    this.couponDatas = []
    if (this.originalCouponDatas && this.originalCouponDatas.length > 0) {
      //取出是这个商品的优惠卷
      for (let i = 0; i < this.products.length; i++) {
        for (let j = 0; j < this.originalCouponDatas.length; j++) {
          if (
            this.products[i].id ===
            this.originalCouponDatas[j].couponDefine!.product!.id
          ) {
            //判断优惠卷是否过期
            //  if (couponDatas[j].endTime! && new Date(couponDatas[j].endTime!).getTime() >new Date().getTime()) {
            this.couponDatas.push(this.originalCouponDatas[j])
            // }
          }
        }
      }
      if (this.couponDatas && this.couponDatas.length > 0) {
        this.isShowCoupon = true
        //选择优惠更高的展示

        for (let i = 0; i < this.couponDatas.length; i++) {
          if (JSON.stringify(this.couponData) === '{}') {
            this.couponData = this.couponDatas[i]
          } else {
            //比较优惠卷的金额大小
            if (
              this.couponDatas[i].couponDefine!.discountAmount! >
              this.couponData.couponDefine!.discountAmount!
            ) {
              this.couponData = this.couponDatas[i]
            }
          }
        }
      } else {
        this.isShowCoupon = false
      }
    }
  }

  async initPayPlatform() {
    //判断是否是支付宝 或者微信 不是 则弹框
    let ua = navigator.userAgent.toLowerCase()
    let isWeixin = ua.indexOf('micromessenger') != -1
    // 从后端判断是否允许登录
    const nopay: any = this.$route.query.nopay
    //判断是否是支付宝
    //if (isWeixin || /AlipayClient/.test(window.navigator.userAgent)) {
    if (!nopay) {
      return true
    } else {
      this.dialogPayText = '打开微信/支付宝 扫码支付'
      if (!this.productOrder || !this.productOrder.products) {
        //弹窗
        this.productOrder = {
          accountId: this.accountId,
          products: this.products,
          orderIntroduction: this.products[0].name,
          totalPrice: this.totalPrice * 100,
          status: 'WAIT_BUYER_PAY',
          couponId: this.couponData ? this.couponData.id : ''
        }
      }
      this.payProduct = {
        productOrder: this.productOrder,
        payType: this.selectPayType
      }
      this.productOrder = await saveProductOrder(this.payProduct)
      this.openComponent2(this.productOrder!.id!)
      return false
    }
  }
  //初始化支付渠道
  initPayType() {
    if (/AlipayClient/.test(window.navigator.userAgent)) {
      this.payChannels = [
        {
          type: 'ALIPAY',
          title: '支付宝',
          icon: '//style.youkeda.com/img/done/website/zhifubao.png'
        }
      ]
      this.selectPayType = 'ALIPAY'
    }
  }

  renderOrder() {
    const data = this.dateFormat(false)
    this.validity = data
    const data3 = this.dateFormat(true)
    this.zhujiao = data3
    //计算价格赋值
    if (this.products) {
      for (let i = 0; i < this.products.length; i++) {
        this.totalPrice += this.products[i].currentPrice!
        this.originalTotalPrice += this.products[i].currentPrice!
        this.productName = this.products[i].name!
        this.productImg = this.products[i].smallLogoUrl!
      }
    }
    this.numberOf = this.products.length
  }

  // 处理订单商品数据
  async getProducts() {
    //从localStorage取数据
    this.products = this.storage.get('products') || []

    // pc 端扫码过来的
    const productsFromUrl = await this.getProductsFromUrl()
    if (productsFromUrl) {
      this.products.push(productsFromUrl)
      // products = [...products, ...productsFromUrl]
    }

    //加入购物车
    //筛选数据
    // let myShoppingCart: ShoppingCart = {}
    // if (products && products.length > 0) {
    //   let newProducts: Product[] = []
    //   for (let i = 0; i < products.length; i++) {
    //     let id = products[i].id
    //     let type = products[i].productType
    //     newProducts.push({
    //       id: id,
    //       productType: type
    //     })
    //   }

    //   myShoppingCart = await saveMystudyPlanTopic({
    //     products: products
    //   })
    //   //合并后删除本地缓存
    //   if (myShoppingCart.reat) {
    //   this.repeat()
    // }
    // }
    // myShoppingCart = await queryMyShoppingCart('')

    this.storage.remove('products')

    if (this.products.length === 0) {
      this.empty = true
      this.isEmpty = false
    } else {
      this.empty = false
      this.isEmpty = true
    }
  }

  /**
   * 从 pc 购买生成的 url 中获取商品信息
   */
  async getProductsFromUrl() {
    const productId = <string>this.$route.query.productid

    if (!productId) {
      return
    }

    return await getCourseProduct(productId)
  }

  //弹窗提示重复购买
  repeat() {
    //弹窗提示重复购买
    this.$ykdmessage({
      message: '重复购买商品，已为你自动删除该商品！',
      duration: 1000,
      cancel: () => {},
      type: 'success'
    })
  }

  dateFormat(isTo: any) {
    var date = new Date()

    var year
    if (!isTo) {
      year = date.getFullYear() + 1
    } else {
      date = new Date(date.getTime() + 7776000000)
      year = date.getFullYear()
    }

    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month =
      date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    var minutes =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var seconds =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    // 拼接
    return year + '-' + month + '-' + day
  }
  //弹窗提示未支付的订单
  async open(productOrders: ProductOrder[]) {
    this.$ykdconfirm({
      title: '您有一条未支付的订单',
      cancelTxt: '放弃支付',
      confirmTxt: '立即支付',
      cancel: async () => {
        //删除这个订单
        const data = await deleteProductOrder({
          accountId: this.accountId,
          productOrderIds: [productOrders![0].id!]
        })
        await this.initOrder()
      },
      confirm: async () => {
        //跳转到当前页面传入一个ordrId
        this.isEmpty = true
        this.productOrderId = productOrders[0].id!
        const productOrder = await queryMyOrder(
          this.accountId,
          '',
          this.productOrderId,
          false
        )
        this.productOrder = productOrder[0]
        //重新计算价格
        this.accountId = productOrder[0].accountId!
        this.products = productOrder[0].products!
        this.renderOrder()
      }
    })
    this.isClickBt = true
  }
  private delHash() {
    return window.location.href
  }
  //保存图片
  saveImg() {
    let myCanvas = document.getElementsByTagName('canvas')
    this.imgUrl = myCanvas[0].toDataURL('image/png')
  }
  //打开二维码弹窗
  openComponent2(productorderId: string) {
    console.log('打开二维码')
    this.localVisible2 = true
    const query = productorderId
    let href =
      'https://www.youkeda.com/home_m/shareorder?productorderId=' + query
    var canvas = document.getElementById('canvas')

    QRCode.toCanvas(canvas, href, function(error) {
      if (error) {
        console.error(error)
      } else {
        console.log('success!=======')
      }
    })
    this.saveImg()
  }

  async weixinpay(data: any) {
    let _this = this
    // @ts-ignore
    window.WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        appId: data.data.appId, //公众号名称，由商户传入
        timeStamp: data.data.timeStamp, //时间戳，自1970年以来的秒数
        nonceStr: data.data.nonceStr, //随机串
        package: data.data.package,
        signType: 'MD5', //微信签名方式：
        paySign: data.data.paySign //微信签名
      },
      function(res: any) {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          _this.callback()
        }
      }
    )
  }

  async callback() {
    await queryWxOrder(this.productOrderId)
  }

  async WaitBuyerPay() {
    const productOrders = await queryWaitBuyerPay(this.accountId)
    if (productOrders && productOrders.length > 0) {
      // 弹窗提示有未支付的订单
      this.open(productOrders)

      return true
    }
    return false
  }
  //支付
  async pay() {
    const result = await this.initPayPlatform()
    if (!result) {
      return
    }

    this.payBtnStatus = '支付中'
    //组装支付的参数
    if (!this.isClickBt) {
      return
    }
    this.isClickBt = false
    if (!this.productOrder || !this.productOrder.products) {
      this.productOrder = {
        accountId: this.accountId,
        products: this.products,
        orderIntroduction: this.products[0].name,
        totalPrice: this.totalPrice * 100,
        status: 'WAIT_BUYER_PAY',
        couponId: this.couponData ? this.couponData.id : ''
      }
    }

    this.payProduct = {
      productOrder: this.productOrder,
      payType: this.selectPayType
    }
    //判断当前平台是否是微信
    var ua = navigator.userAgent.toLowerCase()
    var isWeixin = ua.indexOf('micromessenger') != -1
    if (isWeixin && this.payProduct.payType != 'WEIXIN') {
      //弹窗扫码支付
      //先生成一个订单
      this.payProduct = {
        productOrder: this.productOrder,
        payType: this.selectPayType
      }
      this.productOrder = await saveProductOrder(this.payProduct)
      this.isClickBt = true
      this.openComponent2(this.productOrder!.id!)
      this.payBtnStatus = '立即支付'
      return
    }
    this.payProduct.productOrder!.totalPrice = this.totalPrice * 100

    this.payResult = await pay(this.payProduct)
    if (this.payResult) {
      this.isClickBt = true
    }
    if (this.payResult.payType === 'WEIXIN') {
      this.weixinpay(this.payResult.object)
    }
    if (this.payResult.payType === 'ALIPAY') {
      this.alipayDialog = this.payResult.object.data
      this.$nextTick(() => {
        document.forms[0].submit()
      })
    }

    this.isloading = false
    const timeOut = async () => {
      //查询订单状态是否更新为支付成功
      const productOrder = await queryMyOrder(
        '',
        '',
        this.payResult.orderId!,
        true
      )
      if (
        productOrder.length > 0 &&
        productOrder[0].status! === 'TRADE_PAID_SUCCESS'
      ) {
        //支付成功后课程顾问的二维码选择
        if (productOrder[0].products!.length > 0) {
          for (let i = 0; i < productOrder[0].products!.length; i++) {
            // Java体验课联系大力
            if (productOrder[0].products![i].id!.indexOf('pro_j1test') != -1) {
              this.defalutCode =
                'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/done/website/testDialogcode.png'
            }
            // 就业特训营联系月月
            if (
              productOrder[0].products![i].id!.indexOf('pro_job1test') != -1 ||
              productOrder[0].products![i].id!.indexOf('pro_job2test') != -1
            ) {
              this.defalutCode =
                'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/sandwich/home_m/fast_track/yy_qrcode.jpg'
            }
            // python体验课联系课程小优
            if (productOrder[0].products![i].id!.indexOf('pro_py1test') != -1) {
              //切换二维码
              this.defalutCode =
                'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/done/website/python.png'
            }
          }
        }
        this.paySuccessDialog = true
        this.isloading = false
      } else {
        setTimeout(() => {
          timeOut()
        }, 1000)
      }
    }
    await timeOut()

    this.payBtnStatus = '立即支付'
  }

  //删除购物车商品信息
  // async deleteProduct(productId: string) {
  //   this.deleteProductParam = {
  //     productIds: [productId]
  //   }

  //   const shoppintCart = await deleteMyShoppingCart(this.deleteProductParam)
  //   this.products = shoppintCart.products!
  //   this.$ykdmessage({
  //     message: '删除商品成功！',
  //     duration: 1000,
  //     cancel: () => {},
  //     type: 'success'
  //   })
  //   //计算价格
  //   this.totalPrice = 0
  //   this.originalTotalPrice = 0
  //   this.numberOf = this.products.length
  //   if (this.products) {
  //     for (let i = 0; i < this.products.length; i++) {
  //       this.totalPrice += this.products[i].currentPrice!
  //       this.originalTotalPrice += this.products[i].currentPrice!
  //       this.productName = this.products[i].name!
  //       this.productImg = this.products[i].smallLogoUrl!
  //     }
  //   }
  //   await this.initCoupon()
  //   //重新计算金额
  //   if (JSON.stringify(this.couponData) != '{}') {
  //     this.totalPrice = Number(
  //       (
  //         this.originalTotalPrice -
  //         this.couponData.couponDefine!.discountAmount!
  //       ).toFixed(2)
  //     )

  //     this.coupons = '-' + this.couponData.couponDefine!.discountAmount!
  //   }
  //   //重新初始化优惠卷
  //   // if (this.productOrder) {
  //   //   this.productOrder.products = this.products
  //   //   this.productOrder.totalPrice = this.totalPrice * 100
  //   //   this.payProduct = {
  //   //     productOrder: this.productOrder,
  //   //     payType: this.selectPayType
  //   //   }
  //   //   await saveProductOrder(this.payProduct)
  //   // }
  // }
}
